import {ActionHandlerBase} from "../action-handler-base";
import {IAppRedirectActionPayload} from "@sparkware/uc-sdk-core";

export class AppRedirectActionHandler extends ActionHandlerBase<IAppRedirectActionPayload> {
    async handle(payload: IAppRedirectActionPayload): Promise<void> {
        await this.services.linksNavigation.openUrl({
           url: payload.actionData.url,
           openMode: "newTab"
        });
    }
}